<div class="main">

  <div class="left">
    <div class="header">
      <div class="left-title">
        <ng-select name="selectOperator" id="selectOperator" [items]="selectTypeData"
          [(ngModel)]="typeDateSelected" (change)="dataTypeChnage()" [clearable]="false">
        </ng-select>
      </div>
    </div>

    <div class="data-table box-shadow">
      @if (typeDateSelected == 'Equipments' ) {
        <div class="data-table-box">
          <div class="header-table">
            <span style="width: 2rem;"></span>
            <span>{{ 'HIBOO.MAKE' | translate }}</span>
            <span>{{ 'HIBOO.MODEL' | translate }}</span>
            <span>{{ 'HIBOO.SERIAL_NUMBER' | translate }}</span>
          </div>
          @for (e of tabEquipments; track e; let i = $index) {
            <div class="equipments-item"
              (click)="selectEquipment(e, i, $event)" [ngClass]="{'active': e.isChecked}">
              <span style="width: 2rem;"><input id="checkbox" type="checkbox" [checked]="e.isChecked"
              style="scale: 1.2;"> </span>
              <span>{{e.make}} </span>
              <span>{{e.model}}</span>
              <span [title]="e.serialNumber">{{StaticUtils.truncateString(e.serialNumber,10)}}</span>
            </div>
          }
        </div>
      }


      @if (typeDateSelected == 'Blasts' ) {
        <div class="header-table">
          <span style="min-width: 2rem;"></span>
          <span style="width: 100%;">{{ 'HIBOO.NAME' | translate }}</span>
          <span style="width: 100%;">{{ 'HIBOO.ZONE' | translate }}</span>
          <span style="width: 100%;">{{ 'HIBOO.PROJECT' | translate }}</span>
        </div>
      }
      @if (typeDateSelected == 'Blasts' ) {
        <div class="data-table-box">
          @for (t of tabTir; track t; let i = $index) {
            <div class="equipments-item" (click)="selectBlast(i, $event)"
              [ngClass]="{'active': t.isChecked}">
              <span style="min-width: 2rem;"><input id="checkbox" type="checkbox" [checked]="t.isChecked"
              style="scale: 1.2;"> </span>
              <span style="width: 100%;">{{t.nom}} </span>
              <span style="width: 100%;">{{t.nomZone}}</span>
              <span style="width: 100%;" [title]="t.nomProjet">{{t.nomProjet}}</span>
            </div>
          }
        </div>
      }

    </div>

  </div>


  <div class="center ">

    <div class="header" style="justify-content: space-between;">
      <div class="title">
        <span>{{ 'HIBOO.ASSET_USAGE' | translate }}</span>
      </div>
    </div>

    <div class="center-up">
      <div class="center-left box-shadow">
        <div class="header-sm">
          <div class="title">
            <span>{{ 'HIBOO.EFFICIENCY' | translate }}</span>
          </div>
        </div>
        @if (exploitation) {
          <div class="datas-box">
            @if (exploitation?.operatingPercent !== undefined) {
              <div class="datas">
                <span class="data-label">{{ 'HIBOO.OPERATING_RATE' | translate }}</span>
                <span class="data-value">{{ exploitation?.operatingPercent }} %</span>
              </div>
            }
            @if (exploitation?.usagePercent !== undefined) {
              <div class="datas">
                <span class="data-label">{{ 'HIBOO.USAGE_RATE' | translate }}</span>
                <span class="data-value">{{ exploitation?.usagePercent }} %</span>
              </div>
            }
            @if (exploitation?.idlePercent !== undefined) {
              <div class="datas">
                <span class="data-label">{{ 'HIBOO.IDLE_RATE' | translate }}</span>
                <span class="data-value">{{ exploitation?.idlePercent }} %</span>
              </div>
            }
            @if (exploitation?.hourlyConsumption !== undefined) {
              <div class="datas">
                <span class="data-label">{{ 'HIBOO.FUEL_CONSUMPTION' | translate }}</span>
                <span class="data-value">{{ exploitation?.hourlyConsumption }} L/h</span>
              </div>
            }
          </div>
        }
      </div>

      <div class="center-right box-shadow">
        <div class="header-sm">
          <div class="title">
            <span>{{'GLOBAL.EXPLOITATION' | translate }}</span>
          </div>
        </div>
        @if (exploitation) {
          <div class="datas-box">
            @if (exploitation?.operatingHours) {
              <div class="datas">
                <span class="data-label">{{ 'HIBOO.OPERATING_HOURS' | translate }}</span>
                <span class="data-value">{{
                  StaticUtils.ConvertToStringHoursMinutes(exploitation?.operatingHours)
                }}</span>
              </div>
            }
            @if (exploitation?.usageHours) {
              <div class="datas">
                <span class="data-label">{{ 'HIBOO.USAGE_HOURS' | translate }}</span>
                <span class="data-value">{{ StaticUtils.ConvertToStringHoursMinutes(exploitation?.usageHours)
                }}</span>
              </div>
            }
            @if (exploitation?.idleHours) {
              <div class="datas">
                <span class="data-label">{{ 'HIBOO.IDLE_HOURS' | translate }}</span>
                <span class="data-value">{{ StaticUtils.ConvertToStringHoursMinutes(exploitation?.idleHours)
                }}</span>
              </div>
            }
            @if (exploitation?.fuelUsed) {
              <div class="datas">
                <span class="data-label">{{ 'HIBOO.FUEL_USED' | translate }}</span>
                <span class="data-value">{{exploitation?.fuelUsed | number: '1.0-0'}} L</span>
              </div>
            }
            @if (exploitation?.co2) {
              <div class="datas">
                <span class="data-label">{{ 'HIBOO.CO2_EMISSION' | translate }}</span>
                <span class="data-value">{{exploitation?.co2 | number: '1.0-0'}} Kg</span>
              </div>
            }
          </div>
        }
      </div>

    </div>

  </div>


  <div class="right">

    <div class="header">
      <div class="title">
        <span>{{ 'HIBOO.DETAILS' | translate }}</span>
      </div>
    </div>

    <div class="details-data box-shadow">
      <div class="header-sm">
        <div class="title">
          <span>{{ 'HIBOO.CUMUL_USAGE' | translate }}</span>
        </div>
      </div>
      <div class="datas-box">
        @for (item of cumulativeUsage.cumulativeDatas; track item) {
          <div class="datas">
            <div class="datas-left">
              <span class="value-type">{{ enumToString(item.type) | translate }}</span>
              <span class="date">{{item.date | date: getDateWithTimeFormat() }}</span>
            </div>
            <div class="datas-right">
              <span class="value">{{item.value}}</span>
              <span>{{item?.unit}}</span>
            </div>
          </div>
        }
      </div>

    </div>

  </div>

</div>